import angular from 'angular'
import './print_lookup.service'

angular
  .module('admin.print_lookup', ['admin.print_lookup.service'])
  .controller('PrintLookupCtrl', PrintLookupCtrl)

/** @ngInject */
function PrintLookupCtrl($scope, PrintLookupService, EventService) {
  var vm = this
  vm.items = []
  vm.channels = []
  vm.sets = []
  vm.collectibles = []
  vm.waitChannel = true
  vm.waitSet = true
  vm.customDate = false
  vm.chId = null
  vm.setId = null
  vm.collectibleId = null

  function reloadPagination() {
    vm.perPage = 25
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  EventService.listChannels().then(function(result) {
    vm.channels = result.results
  })

  vm.load = function(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    var collectibleId = !vm.collectibleId ? '' : vm.collectibleId
    if (!collectibleId) return

    PrintLookupService.list(vm.oldPage, 25, collectibleId).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      vm.items = result.results
    })
  }

  vm.pageChanged = function(newPage) {
    vm.load(newPage)
  }

  vm.clear = function() {
    vm.chId = null
    vm.setId = null
    vm.collectibleId = null
    vm.items = []
    vm.sets = []
    vm.collectibles = []
    vm.waitChannel = true
    vm.waitSet = true
    reloadPagination()
  }

  var watch = $scope.$watch('vm.chId', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    EventService.listSets(newVal).then(function(response) {
      vm.sets = response.results
      vm.waitChannel = false
      vm.waitSet = true
      vm.collectibles = []
    })
  })

  var watch1 = $scope.$watch('vm.setId', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    vm.waitSet = false
    EventService.listCollectibles(vm.setId).then(function(response) {
      vm.collectibles = response.results
      vm.waitSet = false
    })
  })

  $scope.$on('$destroy', function() {
    watch()
    watch1()
  })
}
